import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import PropTypes from "prop-types";

const SnackbarContext = createContext(null);

export const useSnackbar = () => {
  return useContext(SnackbarContext);
};

export const SnackbarProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
    id: 0,
  });

  const showSnackbar = useCallback((message, severity = "success") => {
    setSnackbar((current) => ({
      open: true,
      message,
      severity,
      id: current.id + 1,
    }));
  }, []);

  const handleClose = () => {
    setSnackbar((current) => ({ ...current, open: false }));
  };

  useEffect(() => {
    if (!snackbar.open) return undefined;

    const timeoutId = window.setTimeout(handleClose, 3000);
    return () => window.clearTimeout(timeoutId);
  }, [snackbar.id, snackbar.open]);

  return (
    <SnackbarContext.Provider value={showSnackbar}>
      {children}
      <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};

SnackbarProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
